import React from 'react';
import styles from './Sidebar.module.css'; // Assume you have CSS for styling your sidebar
import { useNavigate } from 'react-router-dom';
import logoImage from '../Images/stackFrameWhite.png';
import chevron from '../Images/ChevronBack.png'
import setupIcon from "../Images/tool.png"
import userIcon from "../Images/user.png"
import userDataIcon from '../Images/layers.png'
import trashIcon from '../Images/trashicon.png'
import DeleteModal from './DeleteModal';




function Sidebar({ onSelect, activePage }) {
    const navigate = useNavigate();
    const handleBack = () => {
        navigate('/dashboard'); // Replace '/dashboard' with the actual path to your dashboard
      };
      
    return (
      <div className={styles.sidebar}>
        <div className={styles.navTopParent}>
        <div className={styles.navTopContainer}> 
        <button onClick={handleBack} className={styles.backButton}>
        {/* Icon for Back button */}
        <img src={chevron} alt="back button" style={{ width: '14px', height: '26px', borderRadius: '8px', marginLeft: "3px" }}   />
      </button>
      <div className={styles.logoContainer}>
      <img src={logoImage} alt="stackFrame Logo" style={{ width: '34px', height: '34px', borderRadius: '8px' }}  />
      <p className={styles.navHeader}>stackFrame</p>
      </div>
        </div>
        
      {/* ... (existing code for logo) */}
      {/* Nav items */}
      <div className={styles.navContainer}>
        <div className={activePage === 'project-setup' ? `${styles.navItem} ${styles.active}` : styles.navItem} onClick={() => onSelect('project-setup')}>
        {/* Icon for Project Setup */}
        <img src={setupIcon} alt="Project Set Icon" style={{ width: '24px', height: '24px', borderRadius: '8px' }}  />
        Project Setup
        </div>
        <div className={activePage === 'users' ? `${styles.navItem} ${styles.active}` : styles.navItem} onClick={() => onSelect('users')}>
        {/* Icon for Users */}
        <img src={userIcon} alt="User Tab Icon" style={{ width: '24px', height: '24px', borderRadius: '8px' }}  />
        Users
        </div>
        <div className={activePage === 'user-data' ? `${styles.navItem} ${styles.active}` : styles.navItem} onClick={() => onSelect('user-data')}>
        {/* Icon for User Data */}
        <img src={userDataIcon} alt="User Data Tab Icon" style={{ width: '24px', height: '24px', borderRadius: '8px' }}  />
        User Data
         </div>
      </div>

        </div>
       
     
        {/* <div className={styles.deleteProject} onClick={() => onSelect('delete-project')}>
        <img src={trashIcon} alt="Delete Project Icon" style={{ width: '24px', height: '24px', borderRadius: '8px' }}  />
          Delete Project
        </div> */}
      </div>
    );
  }
  

export default Sidebar;
